'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messagingShape = _reactImmutableProptypes2.default.contains({
  message: _reactImmutableProptypes2.default.mapContains({
    type: _react.PropTypes.string,
    id: _react.PropTypes.string,
    defaultMessage: _react.PropTypes.string
  }),
  values: _reactImmutableProptypes2.default.map,
  duration: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.bool]),
  fieldErrors: _reactImmutableProptypes2.default.contains({
    classification: _react.PropTypes.string,
    message: _react.PropTypes.string
  }),
  failureDuration: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.bool])
});

exports.default = messagingShape;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/bc-prop-types/lib/components/messagingShape.js
// module id = 302
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14